<template>
    <div class="big-screen-container">
        <!-- 顶部标题 -->
        <div class="wheel-replacer" style="width: 90%;margin: 0 auto;">

            <div class="image-display" style="width: 100%;">
                <section style="width: 100%;" v-if="!carImage&&!resultImage">
                    <h1 style="display: flex;flex-direction: row;justify-content: left;"><img style="width: 200px;"  src="https://lg.proxy.shoeswheels.cn/img/logo.webp"/></h1>
                    <div style="width: 100%;">
                        <p><img style="max-width: 100%;" src="../../assets/images/bb4.png"/></p>
                    </div>
                    <ul style="display: flex;flex-direction: row;justify-content: space-between;gap: 40px;margin:0;padding: 0;">
                        <li style="display: flex;flex-direction: column;align-items: center;" v-for="(item,index ) in recommedHubList" :key="index">
                            <img style="width: 100px;height: 100px;" :src="item.goods_img">
                            <div>
                                <p style="height: 28px;line-height: 28px;margin: 0;padding: 0;"><label style="color:#999;">名称：</label> <span>{{item.goods_name}}</span></p>
<!--                                <p style="height: 28px;line-height: 28px;margin: 0;padding: 0;"><label style="color:#999;">价格：</label><span>{{item.shop_price}}</span></p>-->
<!--                                <p style="height: 28px;line-height: 28px;margin: 0;padding: 0;"><label style="color:#999;">孔距：</label><span>{{item.pitch.name}}</span></p><p style="height: 28px;line-height: 28px;margin: 0;padding: 0;"><label style="color:#999;">价格：</label><span>{{item.shop_price}}</span></p>-->
<!--                                <p style="height: 28px;line-height: 28px;margin: 0;padding: 0;"><label style="color:#999;">孔距：</label><span>{{item.pitch.name}}</span></p>-->
                            </div>

                        </li>
                    </ul>
                </section>
                <div v-else>
                    <div class="image-container" :style="{display:isOriginalImage?'block':'none'}">
                        <h4>原始图片</h4>
                        <div class="image-wrapper" ref="carImageContainer">
                            <img :src="carImage" alt="原始汽车" @load="initCanvas" />
                            <canvas ref="detectionCanvas" class="overlay-canvas"></canvas>
                        </div>
                    </div>
                    <div class="image-container" :style="{display:!isOriginalImage?'block':'none'}">
                        <h4>合成结果</h4>
                        <div class="image-wrapper">
                            <canvas style="display: none" ref="resultCanvas" class="result-canvas"></canvas>
                            <img v-if="resultImage" :src="resultImage" alt="合成结果" />
                        </div>
                    </div>
                </div>


            </div>
            <section style="width:100%;margin: 0 auto;">
            <!-- 文件上传区域 -->
                <div class="upload-section">
                </div>
                <footer class="ft_box" style="width: 96%;">
                    <div class="ft_item" style="width: 100%; display: flex;flex-direction: row;align-items: center;justify-content:center;">
                        <div style="padding: 10px 40px;column-gap: 20px; display:flex;row-gap: 30px; flex-direction:row;justify-content: center; justify-items: center; text-align: center; align-items: center;color: #707070;">
                           <p  @click="drawerCar=true"  style="display: flex;flex-direction: column;text-align: center;">
                            <img style="width:50px;height: 50px;margin: 0 auto;" src="../../assets/images/car_icon.png"/>
                             <label style="color: #999">汽车选择</label>
                           </p>
                            <p @click="goContrast" v-if="resultImage" style="flex-direction: column;display: flex;text-align: center;">
                            <img style="width:50px;height: 50px;margin: 0 auto;" src="../../assets/images/contrast_icon.png"/>
                             <label style="color: #999">改装对比</label>
                           </p>
                            <p @click="drawerHub=true" style="display: flex;flex-direction: column; text-align: center;">
                             <img style="width:50px;height: 50px;margin: 0 auto;" src="../../assets/images/hub_icon.png"/>
                             <label style="color: #999">轮毂选择</label>
                            </p>
                            <p @click="goHome" style="display: flex; flex-direction: column; text-align: center;">
                                <img style="width:50px;height: 50px;margin: 0 auto; text-align: center;" src="../../assets/images/home.png"/>
                                <label style="color: #999">返回首页</label>
                            </p>
                        </div>
                    </div>
                </footer>

            <!-- 控制面板 -->
            <div class="control-panel">

                <button v-if="carImage&&newWheelImage" @click="replaceWheels">
                    {{ replacing ? '合成中...' : '合成效果' }}
                </button>
<!--                <button @click="downloadResult" :disabled="!resultImage">-->
<!--                    下载结果-->
<!--                </button>-->

            </div>
            </section>

            <!-- 检测结果显示 -->
            <div v-if="detections.length" class="detection-info" style="display:none">
                <h4>检测到 {{ detections.length }} 个轮毂</h4>
                <div class="detection-list">
                    <div v-for="(det, index) in detections" :key="index" class="detection-item">
                        轮毂 {{ index + 1 }}: 中心位置 ({{ det.center[0] }}, {{ det.center[1] }}),
                        半径 {{ det.radius }}px, 置信度 {{ (det.confidence * 100).toFixed(1) }}%
                    </div>
                </div>
            </div>

            <!-- 图片显示区域 -->

        </div>

        <!-- 轮毂图库抽屉 -->
        <el-drawer
                title="选择轮毂"
                :visible.sync="drawerHub"
                direction="rtl"
                size="50%"
                class="hub-drawer"
        >
            <div class="hub-gallery">
                <div class="gallery-header">

                    <div>
                        <p>
                            <el-input
                                    size="mini"
                                    placeholder="搜索轮毂..."
                                    v-model="hub_keyword"
                                    class="search-input"
                                    @input="searchhub"
                            >
                                <i slot="prefix" class="el-icon-search"></i>
                            </el-input>
                        </p>

                    </div>
                        <div class="category-scroll">
                            <div class="category-tags">
                                <p
                                        v-for="(category, index) in hubCategories"
                                        :key="index"
                                         class="category-tag"
                                        :class="{ active: currentHubCategory === category.id }"
                                        @click="switchHubCategory(category.id)"
                                >
                                    {{ category.name }}
                                </p>
                            </div>
                        </div>
<!--                    <div class="upload-card">-->
<!--                        <h3 style="color: #666">选择轮毂图片</h3>-->
<!--                        &lt;!&ndash; 轮毂图片选择方式切换 &ndash;&gt;-->
<!--                        <div class="input-type-toggle">-->
<!--                            <button-->
<!--                                    @click="showWheelSelection = true"-->
<!--                                    :class="{ active: showWheelSelection }"-->
<!--                            >-->
<!--                                从图库选择-->
<!--                            </button>-->
<!--                            <button-->
<!--                                    @click="showWheelSelection = false"-->
<!--                                    :class="{ active: !showWheelSelection }"-->
<!--                            >-->
<!--                                上传图片-->
<!--                            </button>-->
<!--                        </div>-->

<!--                        &lt;!&ndash; 上传轮毂图片 &ndash;&gt;-->
<!--                        <div v-if="!showWheelSelection">-->
<!--                            <input type="file" @change="handleWheelUpload" accept="image/*" />-->
<!--                            <p class="hint">建议使用透明背景的PNG图片</p>-->
<!--                            &lt;!&ndash;                        <div v-if="newWheelImage" class="image-preview">&ndash;&gt;-->
<!--                            &lt;!&ndash;                            <img :src="newWheelImage" alt="轮毂图片" />&ndash;&gt;-->
<!--                            &lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                        </div>-->

<!--                        &lt;!&ndash; 网络图库选择 &ndash;&gt;-->
<!--                        <div v-if="showWheelSelection" class="wheel-gallery">-->
<!--                            -->
<!--                            <p>-->
<!--                               -->
<!--                            </p>-->
<!--&lt;!&ndash;                            <button @click="openWheelGallery" class="gallery-btn">&ndash;&gt;-->
<!--&lt;!&ndash;                                打开轮毂图库&ndash;&gt;-->
<!--&lt;!&ndash;                            </button>&ndash;&gt;-->

<!--                            &lt;!&ndash; 已选择的轮毂预览 &ndash;&gt;-->
<!--                            &lt;!&ndash;                        <div v-if="selectedWheel" class="selected-wheel">&ndash;&gt;-->
<!--                            &lt;!&ndash;                            <h4>已选择轮毂</h4>&ndash;&gt;-->
<!--                            &lt;!&ndash;                            <img :src="selectedWheel.goods_img" :alt="selectedWheel.name" />&ndash;&gt;-->
<!--                            &lt;!&ndash;                            <p>{{ selectedWheel.name }}</p>&ndash;&gt;-->
<!--                            &lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                        </div>-->
<!--                    </div>-->


                </div>

                <div class="hub-list">
                    <div
                            v-for="(hub, index) in filteredHubList"
                            :key="hub.id"
                            class="hub-item"
                            :class="{ active: selectedHubIndex === index }"
                            @click="selectHub(hub, index)"
                    >
                        <div class="hub-image">
                            <img :src="hub.goods_img" :alt="hub.goods_name" />
                        </div>
                        <div class="hub-info">
                            <h4>{{ hub.goods_name }}</h4>

                        </div>
                    </div>
                </div>

                <div class="gallery-footer">
                    <el-pagination
                            small
                            layout="prev, pager, next"
                            :total="total"
                            :page-size="pageSize"
                            @current-change="handlePageChange"
                    >
                    </el-pagination>
                </div>
            </div>
        </el-drawer>

        <!---->
        <el-drawer
                title="选择车辆"
                :visible.sync="drawerCar"
                direction="rtl"
                size="50%"
                class="hub-drawer"
        >
            <div class="hub-gallery">
                <section class="gallery-header" style="display: flex;flex-direction: row;gap: 20px">
                    <div>
                        <p class="upload-card" style="height: 100%">
                            <span style="color: #666">上传汽车图片</span>
                            <input type="file" @change="handleCarUpload" accept="image/*" />

                        </p>
<!--                        <button @click="detectWheels" :disabled="!carImage || detecting">-->
<!--                            {{ detecting ? '检测中...' : '检测轮毂' }}-->
<!--                        </button>-->
                    </div>
                    <div style="display: flex;flex-direction: column;">
                        <p>
                         <el-input
                                placeholder="搜索汽车..."
                                v-model="car_keyword"
                                style="display: flex;flex-direction: row;align-items: center"
                                size="mini"
                                @input="searchCar"
                        >
                            <i slot="prefix" class="el-icon-search"></i>
                         </el-input>
                        </p>
                        <p>
                            <el-cascader v-model="style_id" style="width: 100%" ref="cascaderCarStyle" @change="getval($event)"
                                         :props="{ value: 'id',label: 'name',children: 'children',checkStrictly: true}" :options="carStyleMenus" clearable></el-cascader>
                        </p>
                    </div>


                </section>

                <div class="hub-list">
                    <div
                            v-for="(item, index) in carList"
                            :key="item.id"
                            class="hub-item"
                            :class="{ active: selectedCarIndex === index }"
                            @click="selectCar(item, index)"
                    >
                        <div class="hub-image">
                            <img :src="item.file_url" :alt="item.title" />
                        </div>
                        <div class="hub-info">
                            <h4>{{ item.title }}</h4>
                        </div>
                    </div>
                </div>

                <div class="gallery-footer">
                    <el-pagination
                            small
                            layout="prev, pager, next"
                            :total="total1"
                            :page-size="pageSize1"
                            @current-change="handlePageChange1"
                    >
                    </el-pagination>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    import axios from 'axios'

    const API_BASE_URL = 'https://jm.shuangma88.com';

    const http = axios.create({
        baseURL: API_BASE_URL,
        timeout: 30000,
        headers: {
            'Content-Type': 'application/json'
        }
    });

    http.interceptors.request.use(
        (config) => {
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    http.interceptors.response.use(
        (response) => {
            return response.data;
        },
        (error) => {
            const errorMsg = error.response?.data?.error || error.message || '网络请求失败';
            console.log(errorMsg)
            return Promise.reject(error);
        }
    );

    export default {
        name: "cHub",
        data() {
            return {
                recommedHubList:[],
                //汽车相关
                drawerCar: false,
                carSearch:'',
                carList:[],
                total1:0,
                currentPage1:1,
                pageSize1:12,
                selectedCarIndex: -1,
                selectedCar:null,
                showCarSelection: true,// 默认显示网络图库

                isOriginalImage:true,
                carImage: null,
                newWheelImage: null,

                // 轮毂选择相关
                showWheelSelection: true, // 默认显示网络图库
                drawerHub: false,
                selectedWheel: null,
                hubSearch: '',
                hub_keyword:'',
                selectedHubIndex: -1,
                pageSize: 12,
                currentPage: 1,

                detections: [],
                detecting: false,
                replacing: false,
                canvasSize: { width: 0, height: 0 },
                resultImage: null,

                // 轮毂列表
                hubList: [],
                filteredHubList: [],
                total: 0,

                // API实例
                api: http,
                hubCategories:[],
                currentHubCategory:'',
                carStyleMenus:[],
                style_id:'',
                car_keyword:''
            };
        },
        created() {
            this.getHubList();
            this.getCarList();
            this.getRecommendHubList();
            this.goodsCategoryTree();
            this.getCarStyleMenus();
        },
        methods: {
            getval() {
                let _this = this;
                const obj = this.$refs['cascaderCarStyle'].getCheckedNodes();
                if(obj.length>0){
                    _this.style_id = obj[0].data.id;
                }else{
                    _this.style_id="";
                }
                this.searchCar();

            },
            getCarStyleMenus(){
                let _this = this;
                let params={
                    access_token:sessionStorage.getItem('token'),
                    company_id:sessionStorage.getItem('company_id'),
                };
                this.$axios.findCarStyleTree(params).then((res)=>{
                    if(res.code == 200) {
                        _this.carStyleMenus=res.data;
                    }
                });
            },
            switchHubCategory(categoryId) {
                this.currentHubCategory = categoryId;
                this.searchhub();
            },
            goodsCategoryTree() {
                let param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                };

                this.$axios.goodsCategoryTree(param).then(res => {
                    if(res.code==200){

                        this.hubCategories=[...this.hubCategories, ...res.data];
                    }

                })
            },
            getRecommendHubList(){
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    pageNum: 1,
                    pageSize: 8,
                    is_recommend:1,
                }

                this.$axios.findHubListP(param).then(res => {
                    if (res.code == 200) {
                        this.recommedHubList = res.data.data;
                    }
                }).catch(error => {
                    console.log(error);
                })
            },
            goHome(){
                this.$router.replace("/welcome");
            },
            goContrast(){
                if(this.resultImage){
                    this.isOriginalImage=!this.isOriginalImage;
                }
            },
            // 处理汽车图片上传
            handleCarUpload(event) {
                const file = event.target.files[0];
                console.log(file)
                this.isOriginalImage=true;
                if (file) {
                    this.carImageFile = file;
                    this.carImage = URL.createObjectURL(file);
                    console.log('carImage', this.carImage)

                    this.detectWheels();
                    // this.detections = [];
                    // this.resultImage = null;
                }
            },

            // 处理轮毂图片上传
            handleWheelUpload(event) {
                const file = event.target.files[0];
                if (file) {
                    this.newWheelImage = URL.createObjectURL(file);
                    this.selectedWheel = null; // 清除选择的网络轮毂
                }
            },

            // 打开轮毂图库
            openWheelGallery() {
                this.drawerHub = true;
            },

            // 选择轮毂
            selectHub(hub, index) {
                this.selectedHubIndex = index;
                this.selectedWheel = hub;
                this.newWheelImage = hub.file_url; // 设置轮毂图片URL
                this.drawerHub = false;
            },

            // 过滤轮毂列表
            filterHubList() {
                if (!this.hubSearch) {
                    this.filteredHubList = this.hubList;
                } else {
                    const search = this.hubSearch.toLowerCase();
                    this.filteredHubList = this.hubList.filter(hub =>
                        hub.name.toLowerCase().includes(search) ||
                        (hub.specification && hub.specification.toLowerCase().includes(search))
                    );
                }
            },

            // 分页处理
            handlePageChange(page) {
                this.currentPage = page;
                this.getHubList();
            },
            //选择车辆
            selectCar(item, index) {
                this.selectedCarIndex = index;
                this.selectedCar = item;
                this.isOriginalImage=true;
                this.carImage = item.file_url; // 设置车辆图片URL
                this.drawerCar = false;
                this.detections=JSON.parse(item.detections);
            },
            searchhub(){
                this.currentPage=1;
                this.hubList=[];
                this.total=0;
                this.getHubList();
            },

            // 分页处理
            handlePageChange1(page) {
                this.currentPage1 = page;
                this.getCarList();
            },
            // 获取轮毂列表
            getHubList() {
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }
                if(this.hub_keyword){
                    param.keywords=this.hub_keyword;
                }else{
                    if(!isNaN(this.currentHubCategory)&&this.currentHubCategory>0){
                        param.cat_id=this.currentHubCategory;
                    }
                }

                this.$axios.findHubListP(param).then(res => {
                    if (res.code == 200) {
                        this.hubList = res.data.data;
                        this.filteredHubList = res.data.data;
                        this.total = res.data.total;
                    }
                }).catch(error => {
                    console.log(error);
                })
            },

            searchCar(){
                this.currentPage1=1;
                this.carList=[];
                this.total1=0;
                this.getCarList();
            },
            //获取汽车
            getCarList() {
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    pageNum: this.currentPage1,
                    pageSize: this.pageSize1
                }
                if(this.car_keyword){
                    param.keywords=this.car_keyword;
                }else{
                    if(this.style_id){
                        param.style_id=this.style_id;
                    }
                }

                this.$axios.findCarListP(param).then(res => {
                    if (res.code == 200) {
                        this.carList = res.data.data;
                        this.total1 = res.data.total;
                    }
                }).catch(error => {
                    console.log(error);
                })
            },

            // 初始化Canvas
            initCanvas() {
                const img = this.$refs.carImageContainer.querySelector('img');
                if (img && img.naturalWidth) {
                    this.canvasSize = {
                        width: img.naturalWidth,
                        height: img.naturalHeight
                    };

                    this.$refs.detectionCanvas.width = this.canvasSize.width;
                    this.$refs.detectionCanvas.height = this.canvasSize.height;
                    this.$refs.resultCanvas.width = this.canvasSize.width;
                    this.$refs.resultCanvas.height = this.canvasSize.height;
                }
            },

            // 检测轮毂
            async detectWheels() {
                if (!this.carImageFile) return;

                this.detecting = true;

                try {
                    const formData = new FormData();
                    formData.append('car_file', this.carImageFile);

                    // 这里需要根据您的API调整
                    // 如果是本地图片，需要先上传到服务器
                    const response = await this.api.post('/api/detect', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    console.error('response:', response);
                    this.detections = response.detections || [];
                    //this.drawDetections();
                } catch (error) {
                    console.error('检测失败:', error);
                    alert('轮毂检测失败，请重试');
                } finally {
                    this.detecting = false;
                }
            },

            // 绘制检测结果
            drawDetections() {
                const canvas = this.$refs.detectionCanvas;
                if (!canvas) return;

                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                this.detections.forEach((det, index) => {
                    const [x1, y1, x2, y2] = det.bbox;
                    const [centerX, centerY] = det.center;
                    const radius = det.radius;

                    // 绘制边界框
                    ctx.strokeStyle = '#00ff00';
                    ctx.lineWidth = 2;
                    ctx.strokeRect(x1, y1, x2 - x1, y2 - y1);

                    // 绘制中心点和圆形
                    ctx.fillStyle = '#ff0000';
                    ctx.beginPath();
                    ctx.arc(centerX, centerY, 5, 0, 2 * Math.PI);
                    ctx.fill();

                    ctx.strokeStyle = '#ffff00';
                    ctx.lineWidth = 2;
                    ctx.beginPath();
                    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
                    ctx.stroke();

                    // 绘制标签
                    ctx.fillStyle = '#00ff00';
                    ctx.font = '16px Arial';
                    ctx.fillText(`Wheel ${index + 1}: ${(det.confidence * 100).toFixed(1)}%`, x1, y1 - 10);
                });
            },

            // 合成替换效果
            async replaceWheels() {

                if (!this.carImage || !this.detections.length || !this.newWheelImage) {
                    alert('请先上传汽车图片、选择轮毂图片并完成检测');
                    return;
                }

                this.replacing = true;
                try {
                    await this.compositeImage();
                    this.isOriginalImage=false;
                } catch (error) {
                    console.error('合成失败:', error);
                    alert('图像合成失败，请重试');
                } finally {
                    this.replacing = false;
                }
            },

            // 合成图像
            async compositeImage() {
                const canvas = this.$refs.resultCanvas;
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                // 绘制原始汽车图片
                const carImg = new Image();
                carImg.crossOrigin = "anonymous";
                await new Promise((resolve, reject) => {
                    carImg.onload = resolve;
                    carImg.onerror = reject;
                    carImg.src = this.carImage;
                });
                ctx.drawImage(carImg, 0, 0, canvas.width, canvas.height);

                // 加载轮毂图片
                const wheelImg = new Image();
                wheelImg.crossOrigin = "anonymous";
                await new Promise((resolve, reject) => {
                    wheelImg.onload = resolve;
                    wheelImg.onerror = reject;
                    wheelImg.src = this.newWheelImage;
                });

                // 替换每个检测到的轮毂
                this.detections.forEach((detection) => {
                    const { center, radius } = detection;
                    const [centerX, centerY] = center;

                    ctx.save();
                    ctx.beginPath();
                    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
                    ctx.clip();

                    const wheelSize = radius * 2;
                    const x = centerX - radius;
                    const y = centerY - radius;
                    ctx.drawImage(wheelImg, x, y, wheelSize, wheelSize);
                    ctx.restore();

                    // 添加边缘效果
                    ctx.strokeStyle = 'rgba(255, 255, 255, 0.3)';
                    ctx.lineWidth = 2;
                    ctx.beginPath();
                    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
                    ctx.stroke();
                });

                this.resultImage = canvas.toDataURL('image/jpeg', 0.9);
            },

            // 下载结果
            downloadResult() {
                if (!this.resultImage) return;

                const link = document.createElement('a');
                link.download = 'wheel_replaced.jpg';
                link.href = this.resultImage;
                link.click();
            },
        }
    };
</script>

<style scoped>
    .big-screen-container {
        min-height: 100vh;
        background-color: #000000;
        background-color: #030409;
        color: #fff;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    }

    .wheel-replacer {
        max-width: 1200px;
        margin: 0 auto;
    }

    .upload-section {
        display: flex;
        gap: 20px;
        margin-bottom: 30px;
    }

    .upload-card {
        flex: 1;
        border: 1px dashed #ddd;
        border-radius: 8px;
        text-align: center;
    }

    .upload-card h3 {
        margin-bottom: 15px;
        color: #ffffff;
    }

    /* 输入类型切换 */
    .input-type-toggle {
        display: flex;
        border: 1px solid #ddd;
        border-radius: 4px;
        overflow: hidden;
    }

    .input-type-toggle button {
        flex: 1;
        border: none;
        background: #f5f5f5;
        cursor: pointer;
        transition: all 0.3s;
    }

    .input-type-toggle button.active {
        background: #007bff;
        color: white;
    }

    .input-type-toggle button:hover:not(.active) {
        background: #e9ecef;
    }

    /* 轮毂图库 */
    .wheel-gallery {
        margin-top: 15px;
    }

    .gallery-btn {
        padding: 10px 20px;
        background: #28a745;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: background 0.3s;
    }

    .gallery-btn:hover {
        background: #218838;
    }

    .selected-wheel {
        margin-top: 15px;
        padding: 15px;
        border: 2px solid #007bff;
        border-radius: 8px;
        background: #f8f9fa;
    }

    .selected-wheel h4 {
        margin-bottom: 10px;
        color: #333;
    }

    .selected-wheel img {
        max-width: 120px;
        max-height: 120px;
        border-radius: 4px;
    }

    /* 轮毂图库抽屉 */
    .hub-drawer {
        z-index: 2000;
    }

    .hub-gallery {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .gallery-header {
        padding: 20px;
        border-bottom: 1px solid #eee;
    }



    .hub-list {
        flex: 1;
        padding: 20px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 15px;
        overflow-y: auto;
    }

    .hub-item {
        border: 2px solid #e9ecef;
        border-radius: 8px;
        padding: 15px;
        cursor: pointer;
        transition: all 0.3s;
    }

    .hub-item:hover {
        border-color: #007bff;
        transform: translateY(-2px);
    }

    .hub-item.active {
        border-color: #007bff;
        background: #f0f8ff;
    }

    .hub-image {
        text-align: center;
        margin-bottom: 10px;
    }

    .hub-image img {
        max-width: 100%;
        max-height: 120px;
        border-radius: 4px;
    }

    .hub-info h4 {
        margin: 0 0 5px 0;
        font-size: 14px;
        color: #333;
    }

    .hub-spec {
        font-size: 12px;
        color: #666;
        margin: 0 0 5px 0;
    }

    .hub-price {
        font-size: 14px;
        color: #e74c3c;
        font-weight: bold;
        margin: 0;
    }

    .gallery-footer {
        padding: 20px;
        border-top: 1px solid #eee;
        text-align: center;
    }

    .image-preview {
        margin-top: 15px;
    }

    .image-preview img {
        max-width: 200px;
        max-height: 150px;
        border-radius: 4px;
    }

    .hint {
        font-size: 12px;
        color: #666;
        margin: 10px 0;
    }

    .control-panel {
        display: flex;
        gap: 10px;
        margin-bottom: 20px;
        justify-content: center;
    }

    .control-panel button {
        padding: 10px 20px;
        border: none;
        border-radius: 4px;
        background-color: #007bff;
        color: white;
        cursor: pointer;
        transition: background-color 0.3s;
    }

    .control-panel button:hover:not(:disabled) {
        background-color: #0056b3;
    }

    .control-panel button:disabled {
        background-color: #6c757d;
        cursor: not-allowed;
    }

    .detection-info {
        margin-bottom: 20px;
        padding: 15px;
        background-color: #f8f9fa;
        border-radius: 4px;
    }

    .detection-list {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 10px;
    }

    .detection-item {
        padding: 8px 12px;
        background-color: #e9ecef;
        border-radius: 4px;
        font-size: 14px;
    }

    .image-display {
        display: flex;
        flex-direction: column;
    }

    .image-container {
        flex: 1;
    }

    .image-container h4 {
        margin-bottom: 10px;
        text-align: center;
        color: #333;
    }

    .image-wrapper {
        position: relative;
        border: 1px solid #ddd;
        border-radius: 4px;
        overflow: hidden;
    }

    .image-wrapper img,
    .overlay-canvas,
    .result-canvas {
        width: 100%;
        height: auto;
        display: block;
    }

    .overlay-canvas {
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none;
    }
    /deep/ body{margin:0 !important;padding: 0;}


    .category-tags, .series-tags {
        display: flex;
        flex-wrap: nowrap;
    }

    .category-tag, .series-tag {
        padding: 6px 12px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 5px;
        color: #333;
        margin-right: 20px;
        font-size: 14px;
        flex-shrink: 0;
        transition: all 0.3s;
    }
    .active {
         background: #1890ff;
         color: #fff;
         transform: scale(1.05);
     }
</style>
